export const CANAL_APP = 'app';
export const CASE_4_ERROR = 'error-validacion-tercero';
export const CASE_7_ERROR = 'error-pago-viaje';
export const CASE_FINISH = 'compra-exitosa';

export const PHONE_CONTACT = '014111111';
export const ACTION_TEL = 'TEL';

export const CROSS_SELLING_APP = 'cross-selling-app';